import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { BaseModal } from 'wbs-components-lib';

import { useUpdateVipLevelMutation } from '@services';

import { AppDispatch, updateVipLevels } from '@store';

import { VipLevelForm, VipLevelFormValues } from '../../VipSettingsForms';

import { VipLevelEditModalProps } from './types';

export const VipLevelEditModal: FC<VipLevelEditModalProps> = ({ isOpened, handleClose, vipLevel }) => {
  const { id, ...initialFormValues } = vipLevel;

  const dispatch = useDispatch<AppDispatch>();

  const [updateVipLevel, { isLoading: isUpdateInProgress }] = useUpdateVipLevelMutation();

  const handleUpdateLevel = async (values: VipLevelFormValues) => {
    const updatedVipTask = await updateVipLevel({
      payload: values,
      vipLevelId: id,
    }).unwrap();

    dispatch(updateVipLevels(updatedVipTask));

    handleClose();
  };

  return (
    <BaseModal headerTitle="Edit VIP level" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <VipLevelForm
        submitButtonCaption="Edit"
        initialValues={initialFormValues}
        isSubmitting={isUpdateInProgress}
        onSubmit={handleUpdateLevel}
      />
    </BaseModal>
  );
};
